import { Component, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLinkActive, RouterLink, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { SidebarService } from '../../services/sidebar.service';

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  route?: string;
  requiresAdmin?: boolean;
  children?: NavItem[];
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  isCollapsed = signal(false);
  expandedMenus: Record<string, boolean> = {};

  // Signal-based current user — initialized in constructor after DI
  currentUser!: ReturnType<typeof toSignal<User | null>>;

  navItems: NavItem[] = [
    { id: 'dashboard', label: 'Dashboard', icon: 'dashboard', route: '/dashboard' },
    { id: 'batch-creation', label: 'Batch Creation', icon: 'batch-creation', route: '/batch-creation' },
    // { id: 'upload', label: 'Bulk Upload', icon: 'upload', route: '/bulk-upload' },
    { id: 'records', label: 'Records & QR Codes', icon: 'records', route: '/records' },
    // { id: 'qr-status', label: 'QR Code Status', icon: 'qr-status', route: '/qr-status' },
    { id: 'reports', label: 'Reports', icon: 'reports', route: '/reports' },
    { id: 'users', label: 'User Management', icon: 'users', route: '/users', requiresAdmin: true },
  ];

  constructor(
    private authService: AuthService,
    private router: Router,
    private sidebarService: SidebarService,
  ) {
    this.currentUser = toSignal<User | null>(this.authService.currentUser, { initialValue: null });
    this.sidebarService.sidebarCollapsed$.subscribe((collapsed) => {
      this.isCollapsed.set(collapsed);
    });
  }

  ngOnInit(): void {}

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  userAvatarLetter(): string {
    const user = this.authService.getCurrentUser();
    return user?.name ? user.name.charAt(0).toUpperCase() : '?';
  }

  toggleSidebar(): void {
    this.sidebarService.toggle();
  }

  closeSidebarOnMobile(): void {
    if (window.innerWidth < 768) this.sidebarService.collapse();
  }

  toggleSubmenu(itemId: string): void {
    this.expandedMenus[itemId] = !this.expandedMenus[itemId];
  }

  isItemActive(route?: string): boolean {
    if (!route) return false;
    return this.router.url.startsWith(route);
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
